import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDrawer from '../../components/CustomDrawer';
import { getAppConfig } from '../../utils/commons';

const useStyles = makeStyles((theme) => ({
    top: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
    bottom: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
}));


export default function TermConditionView(props){
    const {t} = useTranslation();
    const classes = useStyles();
    const [htmlContent, setHtmlContent] = useState(null);

    const appConfig = getAppConfig();
    const content = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.content ? appConfig.about_details.terms_conditions.content : null;
    const urlTerm = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.url ? appConfig.about_details.terms_conditions.url : null;

    useEffect(() => {
        if(content){
            setHtmlContent(content);
        }else if(urlTerm){
            let tagA = document.createElement('a');
            tagA.setAttribute('targe', '_blank');
            tagA.setAttribute('id', 'term_condition_link');
            // tagA.style.display = 'none';
            document.append('tagA');
            document.getElementById('term_condition_link').onclick();
        }
    },[]);

    return (
        <CustomDrawer 
            open={props.open}
            onClose={props.onClose}
        >
            <Grid item xs={12}>
                <Typography variant='h6'>{t('term_condition')}</Typography>
                <div dangerouslySetInnerHTML={{html: htmlContent}}></div>
            </Grid>
        </CustomDrawer>
    );
}